import { handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';

const client = generateClient();

/**
 *
 * @param {*} code
 */
export const getAuth = async (code) => {
  const claim = await client.graphql({
      query:queries.authApIgetClaim,
      variables: {code: code}
  });
  return claim.data.authAPIgetClaim;
}


/**
 *
 * @param {*} sso
 */
export const getUserSession = async (sso) => {
  console.log(`getUserSession called w/ sso: ${sso}`);
  const userSession = await client.graphql(
    {
      query: queries.userApIgetSession, 
      variables: { sso: sso }
    }
  );
  return userSession.data.userAPIgetSession;
}


export const getUpdatingUser = async (userId) => {

  let response = await client.graphql({
    query: queries.userApIgetUpdatingUser, 
    variables: { userId }
  })
  .catch(handleError);

  return response.data.userAPIgetUpdatingUser;
}

export const updateUserHistory = async (resourceId, userId) => {

  let response = await client.graphql({
    query: mutations.userApIupdateUserHistory, 
    variables: { resourceId, userId }
  })
  .catch(handleError);

  return response.data.userAPIupdateUserHistory;
}

export const getBranch = async (userId) => {

  let response = await client.graphql({
    query: queries.userApIgetBranch, 
    variables: { userId }
  })
  .catch(handleError);

  return response.data.userAPIgetBranch;
}
